module.exports = __webpack_public_path__ + "static/media/infant_friendly.b022c905.svg";